import Cookies from 'universal-cookie';

const setCookie = async (name: string, value: string) => {
    const cookies = new Cookies();
    const secureFlag = process.env.NODE_ENV === 'production';
    await cookies.set(name, value, { path: '/', httpOnly: false, secure: secureFlag, sameSite: 'lax' });
    return cookies.get(name);
};

const getCookie = async (name: string) => {
    if (typeof window === 'undefined') {
        const { cookies } = await import('next/headers');
        const cookieStore = await cookies();
        return cookieStore.get(name)?.value || null;
    }
    const cookies = new Cookies();
    return cookies.get(name);
};

const removeCookie = (name: string) => {
    const cookies = new Cookies();
    cookies.remove(name);
};

export { getCookie, removeCookie, setCookie };

